import api from "@/api/axiosInstance";
import { DateTime } from "luxon";
interface User {
    id: number;
    firstName: string;
    lastName: string;
    mobileNumber?: string;
    email: string;
    ownedByCustomerId?: number;
    compublishId?: string;
    picture?: string;
    updatedAt: DateTime;
    createdAt: DateTime;
    createdById: number;
    updatedById: number;
    deletedAt?: DateTime;
    compublishUrl?: string;
}

const getUserById = async (id: number): Promise<User> => {
    const response = (await api.get(`admin/users/${id}`)).data;
    return response.data;
};

export { getUserById };
export type { User };
